import { notifications } from '@mantine/notifications';
import { IconPlus } from '@tabler/icons-react';
import { useApi } from 'api/api-context';
import RemoteSourceForm, { RemoteSourceFormData } from 'components/forms/remote-source/RemoteSourceForm';
import panic from 'errors/panic';
import DashboardLayout from 'layouts/dashboard/DashboardLayout';
import { useNavigate } from 'react-router-dom';
import { CONFIG_REMOTE_SOURCE_PAGE_PATH, REMOTE_SOURCES_PAGE_PATH } from 'routes/paths';
import { SUCCESS_NOTIFICATION_COLOR } from 'utils/constants';

/**
 * Page used to add a new remote source.
 */
export default function AddRemoteSourcePage() {
  const navigate = useNavigate();
  const { getAction } = useApi();

  /**
   * Runs when the form is submitted.
   */
  function onSubmit({ name, type, url, login, password, incomingApiKey, userId }: RemoteSourceFormData) {
    const remoteSourceCreateAction = getAction('RemoteSourceCreate');

    return remoteSourceCreateAction({
      payload: {
        name,
        type,
        url,
        login,
        password,
        incomingApiKey,
        userId: userId ? Number(userId) : undefined,
      },
    })
      .then(({ remoteSourceId }) => {
        notifications.show({
          title: 'Externý zdroj bol vytvorený',
          message: `Externý zdroj ${name} bol úspešne vytvorený.`,
          color: SUCCESS_NOTIFICATION_COLOR,
        });

        navigate(CONFIG_REMOTE_SOURCE_PAGE_PATH.insert({ remoteSourceId }));
      })
      .catch(panic);
  }

  return (
    <DashboardLayout
      title="Pridanie nového externého zdroja"
      breadcrumbs={[
        { title: 'Externé zdroje', link: REMOTE_SOURCES_PAGE_PATH.original },
        { title: 'Pridanie nového externého zdroja' },
      ]}
    >
      <RemoteSourceForm
        onSubmit={onSubmit}
        primaryButtonText="Vytvoriť"
        primaryIcon={<IconPlus stroke="1.5" height={24} width={24} />}
      />
    </DashboardLayout>
  );
}
